import styled from 'styled-components'
import {
  COLOR,
} from '../../../themes'
export const StyleModal = styled.div`
  .modal-container {
    position: fixed;
    inset: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modal-content {
    position: relative;
    background-color: ${COLOR.WHITE};
    border-radius: 8px;
    width: 100%;
    max-width: 960px;
    padding: 11px;
    z-index: 11;
  }
  .close-button {
    position: absolute;
    right: 16px;
    top: 16px;
    border: none;
    background: none;
    cursor: pointer;
  }
  .modal-body {
    margin-top: 32px;
  }
  .modal-image {
    width: 100%;
    height: auto;
    border-radius: 4px;
  }
  .link-button {
    /* Reset button styles */
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    /* Link-like styles */
    cursor: pointer;
  }
  .link-text {
    color: ${( props ) => props.colorTheme ? `${props.colorTheme}` : COLOR.GOLD_1};
    text-decoration: underline;
  }
  .x-button {
    background-color: ${COLOR.WHITE};
    padding: 8px;
    border-radius: 50%;
    opacity: 0.5;
  }
  .error {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
  }
  .image-error {
    width: 250px;
  } 
`
